import { useRouter } from 'next/router';

export const useSlug = () => {
  const router = useRouter();
  const params = router.query;
  const slug = params && Array.isArray(params.slug) ? params.slug?.[0] : params?.slug;

  return slug;
};
